export default __webpack_public_path__ + "static/chalisa-cea3244214195a83345baeecebe3d1bd.webp";